<template>
  <div class="text-darkBlue">
    <h2 class="text-2xl font-semibold">{{ heading }}</h2>
    <p class="text-xs">{{ breadcrumb }}</p>
  </div>
</template>

<script>
export default {
  props: ["heading", "breadcrumb"],
};
</script>

<style></style>
